import { useClassified } from "@/contexts/classified";
/**
 * Return `true` if classified is a new build project (PDP), otherwise return `false`
 */
export const useIsNewBuildProject = () => {
    var _a, _b;
    return ((_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.isNewBuildProject) || false;
};
